/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Popped_Out_TitleInputs */



/**
* | output |
* | --- |
* | "Open in a separate window" |
*
* @param {Artifact_Popped_Out_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_popped_out_title = /** @type {((inputs?: Artifact_Popped_Out_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Popped_Out_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In separatem Fenster geöffnet")
	return /** @type {LocalizedString} */ ("Open in a separate window")
});